import React from "react";
import { useDrop } from "react-dnd";

/**
 * Drop zone on a folder card. A dragged card carries the whole current
 * selection when it is part of one (see ProjectBox's useDrag), so dropping
 * moves every selected project in a single action.
 */
function FolderDropTarget({ folderId, onDrop, children }) {
  const [{ isOver, canDrop, count }, dropRef] = useDrop({
    accept: "PROJECT",
    drop: (item) => {
      const ids =
        item.projectIds && item.projectIds.length
          ? item.projectIds
          : [item.projectId];
      onDrop(ids, folderId);
    },
    collect: (monitor) => {
      const item = monitor.getItem();
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
        count: item
          ? (item.projectIds && item.projectIds.length) || 1
          : 0,
      };
    },
  });

  return (
    <div ref={dropRef} className={`folder-drop-target ${isOver ? "is-over" : ""}`}>
      {children}
      {isOver && canDrop && (
        <div className="folder-drop-badge">
          Move {count} {count === 1 ? "project" : "projects"} here
        </div>
      )}
    </div>
  );
}

export default FolderDropTarget;
